import * as React from 'react'

import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { PaymentApprovalListPageStatuses } from './PaymentApprovalListPage'

export interface PaymentApprovalDetailsPageParams {
  uuid: string
}

const PaymentApprovalDetailsViewChunk = React.lazy(() =>
  import('../containers/PaymentApprovalDetailsView').then(
    ({ PaymentApprovalDetailsView }) => ({
      default: PaymentApprovalDetailsView,
    })
  )
)

export const PaymentApprovalDetailsPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.paymentApprovalDetailsPageTitle)}
      breadcrumbs={[
        {
          name: intl.formatMessage(messages.paymentApprovalListPageTitle),
          link: url('PaymentApprovalListPage', {
            status: PaymentApprovalListPageStatuses.PENDING,
          }),
        },
        {
          name: intl.formatMessage(messages.paymentApprovalDetailsPageTitle),
        },
      ]}
    >
      <PaymentApprovalDetailsViewChunk />
    </Page>
  )
}
